import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { fill_action } from '../../../actions/fillCombo_action';
import { BASE_URL, cityActionId, countryActionId, enterpriseTypeActionId, eventActionId, organisationTypeActionId, stateActionId, toastError, toastSuccess, tradeServiceTypeActionId } from '../../../utils/constants';
import moment from 'moment';
import { countDownDate_action } from '../../../actions/staticAction/static_action';
import { Dropdown, Form } from 'react-bootstrap';
import { get_eventEnquiry_Details_action, insert_update_eventEnquiry_action } from '../../../actions/adminAction/event_enquiry_action';

class Event_Enquiry_Form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMember: '', EventID: '',
            isLoading: false, EventEnquiryID: '',
            MemberID: '', registrationNo: '',
            CompanyName: '',
            PersonName: '', Designation: '',
            CountryID: '', PhoneNo: '', MobileNo: '',
            Email: '', Remark: '', City: '',
            State: '',
            countryList: [], tempCityList: [],
            tempStateList: [],
            cityList: [],
            stateList: [], eventFillList: [],
            isOpenDropDownState: false,
            focusedIndexState: -1,
            isOpenDropDownCity: false,
            focusedIndexCity: -1,
            //validators
            isregTypeErr: '', regNoErr: '', CompanyNameErr: '',
            PersonNameErr: '', DesignationErr: '',
            CountryIDErr: '', PhoneNoErr: '', MobileNoErr: '',
            RemarkErr: '', EmailErr: '', cityErr: '', StateErr: '',
            isViewFlag: false,
            //cms
            cmsSectionData: [], cmsMenuData: [], cmsFooterData: []
        }
        this.slider3Ref = React.createRef()
    }
    async componentDidMount() {
        window.scrollTo(0, 0)
        sessionStorage.setItem("currentPage", 'enquiryForm')
        this.getFillList(countryActionId, '', '', '', '').then(() => {
            this.getFillList(eventActionId, '', '', '', '').then(() => {

                if (sessionStorage.getItem('RoleIDSS') != 5) {
                    this.setState({ EventID: this.props?.location?.state?.EventID, EventEnquiryID: this.props?.location?.state?.EventEnquiryID, isViewFlag: this.props?.location?.state?.isViewFlag }, () => {
                        if ((this.props?.location?.state?.EventEnquiryID != null)) {
                            this.getDetails(this.props?.location?.state?.EventEnquiryID)
                        }
                    })
                }
                this.setState({ isLoading: false })
            })
        })

        // }
    }


    getCountDownDate() {
        const { } = this.state
        this.setState({ isLoading: true })
        return this.props
            .countDownDate_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        const LaunchDate = data.data[0]['enquiryDate']
                        const targetDate = moment.utc(LaunchDate);
                        // Current date in UTC
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        return totalSeconds > 0;
                    }
                    this.setState({ isLoading: false })
                }
                this.setState({ isLoading: false });
                if (data.error == 1) toastError(data.data.ErrorMsg);
                return false;
            });
    }

    getDetails(EventEnquiryID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.get_eventEnquiry_Details_action(EventEnquiryID)
            .then((data) => {
                if (data.error != 1) {
                    const enqData = data?.data?.[0]
                    if (enqData?.CountryID == 91) {
                        this.getFillList(stateActionId, '', enqData?.CountryID, '', '',)
                        this.getFillList(cityActionId, '', enqData?.CountryID, '', '',)
                    }
                    this.setState({
                        CompanyName: enqData?.CompanyName,
                        PersonName: enqData?.PersonName,
                        Designation: enqData?.Designation,
                        CountryID: enqData?.CountryID,
                        State: enqData?.State,
                        City: enqData?.City,
                        MobileNo: enqData?.MobileNo,
                        Email: enqData?.Email,
                        Remark: enqData?.Remark,
                    })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }
    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        else if (actionID === stateActionId) {
                            data.data.length > 0 && this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === cityActionId) {
                            data.data.length > 0 && this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === eventActionId) {
                            data.data.length > 0 && this.setState({
                                eventFillList: data.data,
                            })
                            resolve(true)
                        }

                    }
                })
        })
    }

    inputValidation() {
        const {
            CompanyName, PersonName, Designation, CountryID, City, State, MobileNo, Email, Remark
        } = this.state
        var Err = false
        this.setState({
            CompanyNameErr: '', PersonNameErr: '', DesignationErr: '', CountryIDErr: '', cityErr: '', StateErr: '', MobileNoErr: '', EmailErr: '', RemarkErr: ''
        })
        return new Promise((resolve) => {
            if (CompanyName == '' || CompanyName == null) {
                Err = true
                this.setState({ CompanyNameErr: 'Please enter Company Name' })
            } if (PersonName == '' || PersonName == null) {
                Err = true
                this.setState({ PersonNameErr: 'Please enter Contact Name' })
            } if (Designation == '' || Designation == null) {
                Err = true
                this.setState({ DesignationErr: 'Please enter Designation' })
            } if (CountryID == '' || CountryID == null) {
                Err = true
                this.setState({ CountryIDErr: 'Please Select Country' })
            } if (City == '' || City === null) {
                Err = true;
                this.setState({ cityErr: 'Please Select City' });
            } if (State == '' || State == null) {
                Err = true
                this.setState({ StateErr: 'Please Select State' })
            }
            if (MobileNo == '' || MobileNo == null) {
                Err = true
                this.setState({ MobileNoErr: 'Please enter Mobile Number' })
            } 
            if (Email == '' || Email == null) {
                Err = true
                this.setState({ EmailErr: 'Please Enter Email Address' })
            } if (Remark == '' || Remark == null) {
                Err = true
                this.setState({ RemarkErr: 'Please Enter Remark' })
            }
            resolve(Err)
        })
    }
    BackToEnquiryList() {
        this.props.navigate('/event_enquiry_list')
    }
    submitEnquiry() {
        this.inputValidation().then(res => {
            console.log(res)
            if (!res) {
                const { EventEnquiryID, EventID, CompanyName, PersonName, Designation, CountryID, City, State, MobileNo, Email, Remark } = this.state;
                this.props.insert_update_eventEnquiry_action(EventEnquiryID, EventID, CompanyName, PersonName, Designation, CountryID, City, State, MobileNo, Email, Remark)
                    .then((data) => {
                        if (data.error != 1) {
                            toastSuccess('Remark Submitted Successfully')
                            this.props.navigate('/')
                            this.setState({
                                EventEnquiryID: '', EventID: "", CompanyName: '', PersonName: '',
                                Designation: '', CountryID: '', City: '', State: '', MobileNo: '',
                                Email: '', Remark: ''
                            })
                        }
                    }).catch((e) => console.error(e))
            } else {
                toastError('Please Enter Mandatory Fields')
            }
        })
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    onCountrySelect(e) {
        const { countryList } = this.state
        var CountryID = e.target.value

        this.setState({ CountryID: CountryID, CountryIDErr: "", phone: '', phoneErr: '' })
        var countryCode = CountryID != '' ? countryList.filter(obj => obj.Code == CountryID)[0].CountryCode : ''
        this.setState({
            prephone: `+${countryCode}`,
        })

        this.setState({
            StateErr: '', cityErr: '',
        })
        this.getFillList(stateActionId, '', CountryID, '', '',).then(() => {
            this.getFillList(cityActionId, '', CountryID, '', '',).then(() => {
                this.setState({ isLoading: false })

            })
        })
    }
    handleSelect = (option, mode) => {
        console.log(option.Description, mode, 'selectttttttttt')
        if (mode == 0) {
            this.setState({ State: option.Description, focusedIndexState: -1, tempStateList: [], isOpenDropDownState: false, stateId: option.Code }, () => {
            });
        } else if (mode == 1) {
            this.setState({ City: option.Description, focusedIndexCity: -1, tempCityList: [], isOpenDropDownCity: false, }, () => {
                console.log(this.state.City, 'cityyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy')
            });
        }
    };
    handleHover = (index, mode) => {
        if (mode == 0) {
            this.setState({ focusedIndexState: index });
        } else if (mode == 1) {
            this.setState({ focusedIndexCity: index });
        }
    };
    handleKeyDown = (e, mode) => {
        const { focusedIndexState, tempPincodeList, tempPincodeListModal, focusedIndexPin, focusedIndexPinModal, tempStateList, focusedIndexStateModal, tempStateListModal, tempCityList, focusedIndexCity, focusedIndexCityModal, tempCityListModal, invfocusedIndexCity, invfocusedIndexState } = this.state;
        if (mode == 0) {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                // Move focus down
                this.setState({
                    focusedIndexState: Math.min(focusedIndexState + 1, tempStateList.length - 1),
                }, () => this.scrollIntoView(mode));
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                // Move focus up
                this.setState({
                    focusedIndexState: Math.max(focusedIndexState - 1, 0),
                }, () => this.scrollIntoView(mode));
            } else if (e.key === 'Enter' && focusedIndexState >= 0) {
                // Select the focused item when Enter is pressed
                this.handleSelect(tempStateList[focusedIndexState], mode);
            }
        } else if (mode == 1) {

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                // Move focus down
                this.setState({
                    focusedIndexCity: Math.min(focusedIndexCity + 1, tempCityList.length - 1),
                }, () => this.scrollIntoView(mode));
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                // Move focus up
                this.setState({
                    focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
                }, () => this.scrollIntoView(mode));
            } else if (e.key === 'Enter' && focusedIndexCity >= 0) {
                // Select the focused item when Enter is pressed
                this.handleSelect(tempCityList[focusedIndexCity], mode);
            }

        }
    };
    scrollIntoView = (mode, status) => {
        // console.log(mode, status)
        const { focusedIndexState, focusedIndexStateModal, invfocusedIndexCity, invfocusedIndexState, focusedIndexPin, focusedIndexPinModal, focusedIndexCity, focusedIndexCityModal } = this.state;
        if (mode == 0) {

            const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
            if (!dropdownMenu) return;

            const focusedItem = dropdownMenu.children[focusedIndexState];
            if (!focusedItem) return;

            // Scroll the dropdown menu if the focused item is not fully visible
            const dropdownTop = dropdownMenu.getBoundingClientRect().top;
            const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
            const itemTop = focusedItem.getBoundingClientRect().top;
            const itemBottom = focusedItem.getBoundingClientRect().bottom;
            const menuTop = dropdownMenu.scrollTop;
            const menuHeight = dropdownMenu.offsetHeight;

            if (itemBottom > dropdownBottom) {
                dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
            }
            else if (itemTop < dropdownTop) {
                dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
            }

        } else if (mode == 1) {

            const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
            if (!dropdownMenu) return;

            const focusedItem = dropdownMenu.children[focusedIndexCity];
            if (!focusedItem) return;

            const dropdownTop = dropdownMenu.getBoundingClientRect().top;
            const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
            const itemTop = focusedItem.getBoundingClientRect().top;
            const itemBottom = focusedItem.getBoundingClientRect().bottom;
            const menuTop = dropdownMenu.scrollTop;
            const menuHeight = dropdownMenu.offsetHeight;

            if (itemBottom > dropdownBottom) {
                dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
            }
            else if (itemTop < dropdownTop) {
                dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
            }

        }
    };
    handleSearchChange = (event, mode) => {
        if (mode == 0) {

            this.setState({ State: event.target.value, isOpenDropDownState: event.target.value.length > 0, tempStateList: this.filterItems(event.target.value, mode), focusedIndexState: -1, StateErr: '', stateId: '' });

        } else if (mode == 1) {

            this.setState({ City: event.target.value, isOpenDropDownCity: event.target.value.length > 0, tempCityList: this.filterItems(event.target.value, mode), focusedIndexCity: -1, cityErr: '' });

        }
    };

    filterItems = (searchTerm, mode) => {
        if (mode == 0) {

            return this.state.stateList.filter(item =>
                item.Description.toLowerCase().includes(searchTerm.toLowerCase())
            );

        } else if (mode == 1) {

            return this.state.cityList.filter(item =>
                item.Description.toLowerCase().includes(searchTerm.toLowerCase())
            );

        }
    };

    render() {
        const { isLoading, CompanyName, PersonName, Designation, CountryID, countryList,
            Remark, CompanyNameErr, PersonNameErr, DesignationErr, CountryIDErr, Email, EmailErr,
            RemarkErr, isViewFlag, tempStateList, isOpenDropDownState, eventFillList,
            isOpenDropDownCity, City, tempCityList, cityErr, State, StateErr, EventID,
            cmsSectionData, cmsMenuData, cmsFooterData, } = this.state

        const event = eventFillList.find((event) => event.EventID);
        const eventTitle = event ? event.Title : "Unknown Event";
        console.log(`<h2>Event Enquiry Form - ${eventTitle}</h2>`);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <Header headerNavs={cmsMenuData} />
                <section className="registration_form">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="contact-form">
                                    <div className="first-container"></div>
                                    <div className="second-container">
                                        <h2>
                                            Event Enquiry Form - {eventFillList.find(event => event.EventID === EventID)?.Title}
                                        </h2>
                                        <div className="row">

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Event Name<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={EventID} disabled>
                                                        {eventFillList.length > 0 && eventFillList.map((data) => (
                                                            <option key={data.EventID} value={data.EventID}>{data.Title}</option>
                                                        ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Company Name<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={CompanyName}
                                                        onChange={(e) => this.setState({ CompanyName: e.target.value, CompanyNameErr: '' })}
                                                        className="form-control" maxLength={500}
                                                        placeholder="Enter Company name" disabled={isViewFlag}
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{CompanyNameErr}</span>}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Contact Person<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={PersonName} disabled={isViewFlag} maxLength={100}
                                                        className="form-control" onChange={(e) => this.setState({ PersonName: e.target.value, PersonNameErr: '' })}
                                                        placeholder="Enter First Name"
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{PersonNameErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Designation<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={Designation} disabled={isViewFlag} maxLength={50}
                                                        onChange={(e) => this.setState({ Designation: e.target.value, DesignationErr: '' })}
                                                        className="form-control"
                                                        placeholder="Enter Designation"
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{DesignationErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Country<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={CountryID} disabled={isViewFlag}
                                                        onChange={(e) => { this.onCountrySelect(e) }}
                                                    >
                                                        <option value={''}>Select Your Country</option>
                                                        {
                                                            countryList.length > 0 && countryList.map((data) => (
                                                                <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{CountryIDErr}</span>}
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>City<span className="red-star text-danger">*</span></label>
                                                    <Form.Control
                                                        type="text" value={City} disabled={isViewFlag}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const isValid = /^[a-zA-Z\s]+$/.test(value) || value === '';
                                                            if (isValid) {
                                                                this.handleSearchChange(e, 1);

                                                            }
                                                        }}
                                                        onFocus={() => City?.length > 0 && this.setState({ isOpenDropDownCity: true })}
                                                        onBlur={() => setTimeout(() => {
                                                            this.setState({ isOpenDropDownCity: false })
                                                        }, 500)}
                                                        onKeyDown={(e) => this.handleKeyDown(e, 1)}

                                                        placeholder="Enter City"
                                                        maxLength={100}
                                                    />
                                                    {isOpenDropDownCity && tempCityList.length > 0 && (
                                                        <Dropdown.Menu show style={{ position: 'absolute', width: '100%', zIndex: 1, maxHeight: '200px', overflowY: 'auto', padding: 0 }}>
                                                            {tempCityList.map((item, index) => (
                                                                <Dropdown.Item key={index} onClick={() => {
                                                                    this.handleSelect(item, 1)

                                                                }}
                                                                    style={{
                                                                        whiteSpace: 'normal', height: '40px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                        backgroundColor: this.state.focusedIndexCity === index ? '#744587' : 'transparent',
                                                                        color: this.state.focusedIndexCity === index ? 'white' : 'black'
                                                                    }}
                                                                    onMouseEnter={() => this.handleHover(index, 1)}
                                                                >
                                                                    {item.Description}
                                                                </Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    )}
                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{cityErr}</span>}
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>State<span className="red-star text-danger">*</span></label>
                                                    <Form.Control
                                                        type="text" disabled={isViewFlag}
                                                        value={State}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const isValid = /^[a-zA-Z\s]+$/.test(value) || value === '';
                                                            if (isValid) {
                                                                this.handleSearchChange(e, 0);
                                                            }
                                                        }}
                                                        onFocus={() => State?.length > 0 && this.setState({ isOpenDropDownState: true })}
                                                        onBlur={() => setTimeout(() => {
                                                            this.setState({ isOpenDropDownState: false })
                                                        }, 500)}
                                                        onKeyDown={(e) => this.handleKeyDown(e, 0)}

                                                        placeholder="Enter State"
                                                        maxLength={100}
                                                    />
                                                    {isOpenDropDownState && tempStateList.length > 0 && (
                                                        <Dropdown.Menu show style={{ position: 'absolute', width: '100%', zIndex: 1, maxHeight: '200px', overflowY: 'auto', padding: 0 }}>
                                                            {tempStateList.map((item, index) => (
                                                                <Dropdown.Item key={index} onClick={() => {
                                                                    this.handleSelect(item, 0)
                                                                }}
                                                                    // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                    style={{
                                                                        whiteSpace: 'normal', height: '40px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                        backgroundColor: this.state.focusedIndexState === index ? '#744587' : 'transparent',
                                                                        color: this.state.focusedIndexState === index ? 'white' : 'black'
                                                                    }}
                                                                    onMouseEnter={() => this.handleHover(index, 0)}
                                                                >
                                                                    {item.Description}
                                                                </Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    )}
                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{StateErr}</span>}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Mobile No. <span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={this.state.MobileNo}
                                                        disabled={this.state.isViewFlag}
                                                        maxLength={CountryID == 91 ? 10 : 20}
                                                        onChange={(e) => {
                                                            const mobile = e.target.value;
                                                            if (/^\d*$/.test(mobile)) {  // Only numbers allowed
                                                                this.setState({ MobileNo: mobile, MobileNoErr: '' });
                                                            } else {
                                                                this.setState({ MobileNoErr: 'Only numbers are allowed' });
                                                            }
                                                        }}
                                                        className="form-control"
                                                        placeholder="Enter Mobile No"
                                                    />
                                                    {this.state.MobileNoErr && <span className="text-danger text-start text-left d-block ml-2">{this.state.MobileNoErr}</span>}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Email Address<span className="red-star text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        value={Email}
                                                        disabled={isViewFlag} maxLength={100}
                                                        onChange={(e) => {
                                                            const email = e.target.value;
                                                            this.setState({
                                                                Email: email,
                                                                EmailErr: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) || email === '' ? '' : 'Invalid email format'
                                                            });
                                                        }}
                                                        className="form-control"
                                                        placeholder="Enter Email Address"
                                                    />
                                                    {EmailErr && <span style={{ color: 'red', fontSize: '12px' }}>{EmailErr}</span>}

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Message/Remark<span className="red-star text-danger">*</span></label>
                                                    <textarea rows={2} value={Remark} maxLength={1000}
                                                        onChange={(e) => this.setState({ Remark: e.target.value, RemarkErr: '' })}
                                                        className="form-control" disabled={isViewFlag}
                                                        placeholder="Type here..."
                                                        defaultValue={""}
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{RemarkErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-12 text-center">
                                                {isViewFlag ? <>
                                                    <button className="btn btn-primary submit_btn" onClick={() => this.BackToEnquiryList()}>
                                                        Back
                                                    </button>
                                                </> : <>
                                                    <button className="btn btn-primary submit_btn" disabled={isViewFlag} onClick={() => this.submitEnquiry()}>
                                                        Submit
                                                    </button>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer footerData={cmsFooterData} />
            </>
        )

    }
}

export default withRouter(connect(null, { fill_action, get_eventEnquiry_Details_action, countDownDate_action, insert_update_eventEnquiry_action })(Event_Enquiry_Form));